import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-gap-6 tw-items-start tw-mb-4 tw-flex-wrap" }
const _hoisted_2 = { key: 1 }

import ProjectBanner from "@/core/uni-components/ProjectBanner.vue";
import EstimateCard from "@/core/uni-components/EstimateCard.vue";
import { useRouter } from "vue-router";
import { TRADE_ESTIMATES_ROUTE } from "../routes";
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { ref } from "vue";
import CommonLoader from "@/core/components/CommonLoader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradesEstimates',
  props: { projectId: { type: Number || String } },
  setup(__props) {

const store = useStore();
const isLoading = ref(false);
const router = useRouter();
const searchQuery = ref("");

const tradeEstimateData = computed(() => {
  return store.getters[`${TRADE_ESTIMATE_STORE}/getTradeEstimate`] || [];
});
const filteredEstimates = computed(() =>
  tradeEstimateData.value.filter(
    (estimate: any) =>
      estimate &&
      estimate.workStation?.name &&
      estimate.workStation?.name
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase())
  )
);

const redirectTo = (value: string) => {
  router.push({ name: TRADE_ESTIMATES_ROUTE, params: { estimateId: value } });
};

const handleSearchUpdate = (query: string) => {
  searchQuery.value = query;
};
const props = __props;

onMounted(async () => {
  try {
    if (props.projectId) {
      isLoading.value = true;
      const res = await store.dispatch(
        `${TRADE_ESTIMATE_STORE}/getTradeEstimateData`,
        {
          projectId: props.projectId,
        }
      );
    } else {
      throw "Project id not found";
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ProjectBanner, { onUpdateSearch: handleSearchUpdate }),
    _createElementVNode("div", _hoisted_1, [
      (isLoading.value)
        ? (_openBlock(), _createBlock(CommonLoader, { key: 0 }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEstimates.value, (estimate) => {
        return (_openBlock(), _createBlock(EstimateCard, {
          class: "",
          key: estimate.id,
          estimateDetails: estimate,
          onOnViewEstimateDetails: ($event: any) => (redirectTo(estimate?.id))
        }, null, 8, ["estimateDetails", "onOnViewEstimateDetails"]))
      }), 128)),
      (!filteredEstimates.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "No Estimates"))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})